import { ErrorBoundary as AntdErrorBoundary } from "@empglabs/backoffice-ui-kit"

const ErrorBoundary = props => {
  return <AntdErrorBoundary {...props} />
}

export default ErrorBoundary
